import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingCount = signal(0);
    readonly isLoading = computed(() => this.loadingCount() > 0);

    // para el control externo del loading
    readonly loadingEnabled = signal(true);

    constructor() { }

    show(): void {
        if (this.loadingEnabled()) {
            this.loadingCount.update(x => x + 1);
        }
    }

    hide(): void {
        if (this.loadingEnabled()) {
            this.loadingCount.update(x => Math.max(x - 1, 0));
        }
    }

    reset(): void {
        this.loadingCount.set(0);
    }

    disableLoading(): void {
        this.loadingEnabled.set(false);
    }

    enableLoading(): void {
        this.loadingEnabled.set(true);
    }
}
